import { resolvePayDeadlineMs } from "./cashierDateTime";

export interface CashierExpiredPrompt {
  isExpired: boolean;
  title: string;
  description: string;
}

const SESSION_EXPIRED_PATTERNS = [/收银会话已过期/, /收银会话已关闭/, /会话已过期/];
const ORDER_EXPIRED_PATTERNS = [
  /订单已失效/,
  /业务订单不可支付/,
  /订单已过期/,
  /订单已超过支付有效期/,
  /订单已取消/,
  /已取消/,
];

export function resolveCashierExpiredError(
  message?: string | null
): CashierExpiredPrompt {
  const text = message?.trim() ?? "";
  if (!text) {
    return { isExpired: false, title: "", description: "" };
  }
  if (SESSION_EXPIRED_PATTERNS.some((pattern) => pattern.test(text))) {
    return {
      isExpired: true,
      title: "支付已过期",
      description: "当前收银会话已失效，请返回商户页面重新下单后再支付。",
    };
  }
  if (ORDER_EXPIRED_PATTERNS.some((pattern) => pattern.test(text))) {
    return {
      isExpired: true,
      title: "订单已失效",
      description: "该订单已超过支付有效期或已被取消，请返回商户页面重新下单。",
    };
  }
  return { isExpired: false, title: "", description: "" };
}

export function isCashierPayWindowExpired(
  createdAt?: string | Date | null,
  expireAt?: string | Date | null
): boolean {
  const deadline = resolvePayDeadlineMs(createdAt, expireAt);
  return deadline != null && deadline <= Date.now();
}

export function resolveCashierLocalExpiredPrompt(): CashierExpiredPrompt {
  return {
    isExpired: true,
    title: "支付已过期",
    description: "订单支付时间已结束，请返回商户页面重新下单。",
  };
}
